"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BELL_INDICATOR_ACTIVE = void 0;
var client_1 = require("@apollo/client");
var useIsBellActive = function () {
    var _a;
    var _b = (0, client_1.useQuery)(exports.BELL_INDICATOR_ACTIVE), data = _b.data, loading = _b.loading, error = _b.error, refetch = _b.refetch;
    return {
        isActive: (_a = data === null || data === void 0 ? void 0 : data.ccIsBellIndicatorActive) === null || _a === void 0 ? void 0 : _a.isBellIndicatorActive,
        loading: loading,
        error: error,
        refetch: refetch,
    };
};
exports.BELL_INDICATOR_ACTIVE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query CcIsBellIndicatorActive {\n    ccIsBellIndicatorActive {\n      isBellIndicatorActive\n    }\n  }\n"], ["\n  query CcIsBellIndicatorActive {\n    ccIsBellIndicatorActive {\n      isBellIndicatorActive\n    }\n  }\n"])));
exports.default = useIsBellActive;
var templateObject_1;
//# sourceMappingURL=useIsBellActive.js.map